import styled from 'styled-components';
import { MAX_WRAPPER_SIZE } from '../../../../settings';

export default {
    FooterContainer: styled.div.attrs({ className: 'footer-container' })`
        width: 100vw;
        max-width: ${MAX_WRAPPER_SIZE};
        margin: 0 auto;
        padding: 50px 8px 34px;
        border-top: 1px solid #B9C0C2;

        @media (min-width: 600px) {
            padding-top: 65px;
            padding-bottom: 75px;
            margin-top: ${props => props.status ? '0' : '100px'};
        }
    `,
    FooterWrapper: styled.div.attrs({ className: 'footer-wrapper' })`
        max-width: ${MAX_WRAPPER_SIZE};
        min-width: 320px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding-left: 24px;
        padding-right: 24px;
        flex-wrap: wrap;
        box-sizing: border-box;
        
        @media (min-width: 600px) {
            justify-content: space-between;
            align-items: flex-start;
            height: auto;
            padding-left: 8px;
            padding-right: 8px;
        }
        
        @media(min-width: 900px){
          .footer-part:first-child{
            width: 60%;
          }
          .footer-part:last-child{
            width: 40%;
          }
        }
        
        @media (min-width: 1220px) {
            padding-left: 0;
            padding-right: 0;
        }
    `,
    FooterPart: styled.div.attrs({ className: 'footer-part' })`
        display: flex;
        flex-direction: column;
        align-items: self-start;
        width: 100%;
        @media (min-width: 600px) {
            width: initial;
            align-self: flex-end;
        }
        @media (min-width: 900px) {
            padding-left: 0;
        }
    `,
    FooterBigText: styled.span`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 18px;
        font-weight: 400;
        line-height: 36px;
        color: #1A1A1A;
        letter-spacing: 0.25px;
        padding-top: 30px;
        
        @media (min-width: 600px) {
            padding-top: 0;
        }
        @media (min-width: 900px) {
            margin-bottom: 9px;
            padding-left: 0;
            font-size: 18px;
        }
    `,
    FooterText: styled.span`
        font-family:  NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 229%;
        color: #5B6164;
        -webkit-font-smoothing: antialiased;
        font-style: normal;
        font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        font-feature-settings: "lnum";
        @media (min-width: 900px) {
            line-height: 30px;
            padding-left: 0;
            font-size: 16px;
            margin-bottom: 10px;
        }
    `,
    RedLink: styled.a.attrs({ className: 'grey-link' })`
        color: #5B6164;
        text-decoration: none;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-weight: 400;
        &:hover {
            text-decoration: underline;
        }
    `,
    RedLinkUnderlined: styled.a.attrs({ className: 'grey-link-underlined' })`
        color: #5B6164;
        text-decoration: none;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-weight: 400;
        &:hover {
            text-decoration: underline;
        }
    `,
};
